export default {
  '3D Rotate': 'Xoay 3D',
  'API Key': 'API Key',
  'Academic Rank': 'Học hàm',
  'Academic Rank/Degree': 'Học hàm/Học vị',
  'Account List': 'Danh sách tài khoản',
  'Acquisition Time (s)': 'Thời gian nhận (s)',
  'Active viewport has no displayed image':
    'Không có hình ảnh trong khung hình',
  'Add Account': 'Thêm tài khoản',
  'Add Device': 'Thêm thiết bị',
  'Add Filter Condition': 'Thêm điều kiện lọc',
  'Add Filter': 'Thêm bộ lọc',
  'Add Group Account': 'Thêm nhóm tài khoản',
  'Add Institution': 'Thêm cơ sở',
  'Add Facility': 'Thêm cơ sở',
  'Add Layout Report': 'Thêm mẫu in báo cáo',
  'Add Order': 'Thêm chỉ định',
  'Add Procedure Group': 'Thêm nhóm dịch vụ',
  'Add Procedure': 'Thêm dịch vụ',
  'Add Body Part': 'Thêm bộ phận chụp',
  'Edit Body Part': 'Chỉnh sửa bộ phận chụp',
  'Add Department': 'Thêm khoa phòng',
  'Edit Department': 'Chỉnh sửa khoa phòng',
  'Add Role': 'Thêm nhóm quyền',
  'Add Rule CAD': 'Thêm quy tắc CAD',
  'Add Template': 'Thêm mẫu báo cáo',
  'Add User': 'Thêm người dùng',
  'Adjust Window': 'Điều chỉnh cửa sổ',
  'All exam for this patient id': 'Tất cả các xét nghiệm cho mã người bệnh này',
  'All files uploading will be canceled.':
    'Tất cả các tệp đang tải lên sẽ bị hủy',
  'All time': 'Tất cả',
  'All Time': 'Tất cả',
  'Approve Date': 'Thời gian duyệt báo cáo',
  'Approved By': 'Người duyệt báo cáo',
  'Are you sure you want to close?':
    'Các tệp đang tải lên sẽ bị hủy, bạn có muốn đóng đóng cửa sổ?',
  'Are you sure you want to delete share?': 'Bạn có muốn xóa chia sẻ ca chụp?',
  'Arrived At': 'Thời gian đến',
  'Assign Radiologist': 'Chỉ định bác sĩ',
  'Assign Type': 'Loại chỉ định',
  'Assigned At': 'Thời gian được chỉ định',
  'Assigned List': 'Danh sách được chỉ định',
  'Assigned To': 'Chỉ định tới',
  'File Attachment': 'Tệp đính kèm',
  'Auto Send to CAD': 'Tự động gửi tới CAD',
  'Body Part': 'Bộ phận chụp',
  'CAD Not Supported': 'CAD không hỗ trợ',
  'CAD Suggestion': 'Gợi ý của CAD',
  'CAD need more time for diagnosing': 'CAD cần thêm thời gian chẩn đoán',
  'Can not start camera': 'Không thể khởi chạy máy ảnh',
  'Can not stop camera': 'Không thể tắt máy ảnh',
  'Open Camera': 'Mở máy ảnh',
  'Capture Image': 'Chụp hình',
  'Capture Video': 'Mở máy ảnh',
  'Record Video': 'Quay video',
  Fullscreen: 'Toàn màn hình',
  'Change Device': 'Thay đổi thiết bị',
  'Change Password': 'Thay đổi mật khẩu',
  'Change Value DICOM Fields': 'Đổi giá trị các trường DICOM',
  'Choose Report Template': 'Chọn mẫu báo cáo',
  'Clear Filter': 'Xóa bộ lọc',
  'Confirm Password': 'Xác nhận mật khẩu',
  'Create Order': 'Tạo chỉ định',
  'Create RT Report': 'Tạo báo cáo RT',
  'Create Report': 'Tạo báo cáo',
  'Create error': 'Tạo lỗi',
  'Created At': 'Thời gian tạo',
  'Data List': 'Danh sách dữ liệu',
  'Demographic Info': 'Thông tin bệnh nhân',
  'Device Name': 'Tên thiết bị',
  'Device Type': 'Kiểu thiết bị',
  'Dicom Adapter': 'Bộ chuyển đổi DICOM',
  'Dicom Data': 'Dữ liệu DICOM',
  'Drag and drop files here or': 'Kéo và thả các tệp tại đây hoặc',
  'Edit Account': 'Cập nhật tài khoản',
  'Edit Assign Radiologist': 'Cập nhật chỉ định bác sĩ',
  'Edit Device': 'Cập nhật thiết bị',
  'Edit Filter': 'Cập nhật bộ lọc',
  'Edit Group Account': 'Cập nhật nhóm tài khoản',
  'Edit Institution': 'Cập nhật cơ sở',
  'Edit Facility': 'Cập nhật cơ sở',
  'Edit Layout Report': 'Cập nhật mẫu báo cáo',
  'Edit Order': 'Cập nhật chỉ định',
  'Edit Procedure Group': 'Cập nhật nhóm dịch vụ',
  'Edit Procedure': 'Cập nhật dịch vụ',
  'Edit Report': 'Cập nhật báo cáo',
  'Edit Role': 'Cập nhật nhóm quyền',
  'Edit Rule CAD': 'Cập nhật quy tắc CAD',
  'Edit Template': 'Chỉnh sửa mẫu báo cáo',
  'Enter AETitle': 'Nhập AETitle',
  'Enter API Key': 'Nhập API Key',
  'Enter Academic Rank': 'Nhập học hàm',
  'Enter Academic Rank/Degree': 'Nhập học hàm/học vị',
  'Enter Address': 'Nhập địa chỉ',
  'Enter Age': 'Nhập tuổi',
  'Enter Approver Name': 'Nhập tên người phê duyệt',
  'Enter Birthday': 'Nhập ngày tháng năm sinh',
  'Enter Body Part': 'Nhập bộ phận chụp',
  'Enter Conclusion': 'Nhập kết luận',
  'Enter Content': 'Nhập nội dung',
  'Enter Device Name': 'Nhập tên thiết bị',
  'Enter Diagnoses': 'Nhập chẩn đoán',
  'Enter Email': 'Nhập Email',
  'Enter Expired Date': 'Nhập ngày hết hạn',
  'Enter Filter Name': 'Nhập tên bộ lọc',
  'Enter Full Name': 'Nhập họ và tên',
  'Enter Gender': 'Nhập giới tính',
  'Enter Group Name': 'Nhập tên nhóm',
  'Enter HIS ID': 'Nhập mã HIS',
  'Enter Hostname/IP': 'Nhập tên máy chủ/IP',
  'Enter Institution Name': 'Nhập tên cơ sở',
  'Enter Facility Name': 'Nhập tên cơ sở',
  'Enter Layout Name': 'Nhập tên mẫu',
  'Enter Order Doctor': 'Nhập bác sĩ chỉ định',
  'Enter Order Group': 'Nhập mã chỉ định',
  'Enter Pass Code': 'Nhập mật mã',
  'Enter Password': 'Nhập mật khẩu',
  'Enter Patient ID': 'Nhập mã người bệnh',
  'Enter Patient Name': 'Nhập tên người bệnh',
  'Enter Phone Number': 'Nhập số điện thoại',
  'Enter Procedure Code': 'Nhập mã dịch vụ',
  'Enter Procedure Group Name': 'Nhập tên nhóm dịch vụ',
  'Enter Procedure Name': 'Nhập tên dịch vụ',
  'Enter Department Code': 'Nhập mã khoa phòng',
  'Enter Department Name': 'Nhập tên khoa phòng',
  'Enter Body Part Name': 'Nhập tên bộ phận',
  'Enter Refer Doctor': 'Nhập bác sĩ giới thiệu',
  'Enter Role Code': 'Nhập mã nhóm quyền',
  'Enter Role Name': 'Nhập tên nhóm quyền',
  'Enter Rule Name': 'Nhập tên quy tắc',
  'Enter Source AETitle': 'Nhập nguồn AETitle',
  'Enter Template Code': 'Nhập mã mẫu',
  'Enter Template Name': 'Nhập tên mẫu',
  'Enter Type': 'Nhập loại',
  'Enter Username': 'Nhập tên đăng nhập',
  'Enter Visit ID': 'Nhập mã lượt khám',
  'Enter address': 'Nhập địa chỉ',
  'Enter body part': 'Nhập bộ phận chụp',
  'Enter confirm password': 'Nhập xác nhận mật khẩu',
  'Enter description': 'Nhập mô tả',
  'Enter device name': 'Nhập tên thiết bị',
  'Enter in the format': 'Nhập theo định dạng',
  'Enter institution code': 'Nhập mã cơ sở',
  'Enter interval': 'Nhập khoảng thời gian',
  'Enter password': 'Nhập mật khẩu',
  'Enter port': 'Nhập cổng',
  'Enter procedure code': 'Nhập mã dịch vụ',
  'Enter short name': 'Nhập tên viết tắt',
  'Enter username': 'Nhập tên đăng nhập',
  'Error Message': 'Đã xảy ra lỗi, vui lòng thử lại sau',
  'Exam By Radiologist': 'Báo cáo chi tiết theo bác sĩ',
  Exams: 'Danh sách ca chụp',
  'Exam Info': 'Thông tin ca chụp',
  'Expired At': 'Thời gian hết hạn',
  'Expired Date': 'Ngày hết hạn',
  'Export CSV': 'Xuất CSV',
  'FOR INVESTIGATIONAL USE ONLY': 'Chỉ dùng cho nghiên cứu',
  'File Name': 'Tên tập tin',
  'File Type': 'Loại tập tin',
  'Film Size': 'Kích thước film',
  'Film Type': 'Loại film',
  'Filter Management': 'Quản lý bộ lọc',
  'Filter Name': 'Tên bộ lọc',
  'Filter Type': 'Loại bộ lọc',
  'Freehand Scalpel': 'Cắt thủ công',
  'Full Name': 'Họ và tên',
  'Generate Key': 'Tạo API Key',
  'Generate Link': 'Tạo liên kết',
  'Go back Home': 'Về trang chủ',
  'Group Account List': 'Danh sách nhóm tài khoản',
  'Group Account': 'Nhóm tài khoản',
  'Group Name': 'Tên nhóm',
  'HIS ID': 'Mã HIS',
  // 'Half Life (s)': '',
  'Header:About': 'Tiêu đề: giới thiệu',
  'Header:Logout': 'Tiêu đề: Đăng xuất',
  'Header:Preferences': 'Tiêu đề: mục ưu tiên',
  'Hostname/IP': 'Tên máy chủ/IP',
  'INVESTIGATIONAL USE ONLY': 'Chỉ sử dụng nghiên cứu',
  'Image height (px)': 'Chiều cao hình ảnh (px)',
  'Image preview': 'Xem trước hình ảnh',
  'Image width (px)': 'Độ rộng hình ảnh (px)',
  'Import files': 'Nhập các tệp',
  'Injection Time (s)': 'Thời gian tiêm thuốc',
  'Institution Code': 'Mã cơ sở',
  'Facility Code': 'Mã cơ sở',
  'Institution Name': 'Tên cơ sở',
  'Facility Name': 'Tên cơ sở',
  'Interval(s)': 'Khoảng thời gian',
  'Invalid image': 'Ảnh không hợp lệ',
  'Invalid username': 'Tên đăng nhập không hợp lệ',
  'Key Image': 'Ảnh bệnh lý',
  'Last 30 days': '30 ngày gần nhất',
  'Last Month': 'Tháng gần nhất',
  'Layout List': 'Danh sách mẫu',
  'Layout Name': 'Tên mẫu',
  'Layout Report': 'Mẫu in báo cáo',
  'Loading recent report...': 'Đang tải báo cáo gần đây...',
  Match: 'Ghép',
  'Match Order': 'Ghép chỉ định',
  'Match Status': 'Trạng thái ghép',
  'Medium Type': 'Loại film',
  'Merge Order With Same Patient': 'Gộp chỉ định của cùng một người bệnh',
  'NON-DICOM': 'NON-DICOM',
  'New Report': 'Tạo báo cáo',
  'No Order': 'Không có chỉ định',
  'No layout selected yet': 'Chưa có mẫu nào được chọn',
  'No permission found': 'Không tìm thấy quyền',
  'No selected order': 'Không có chỉ định nào được chọn',
  'No tracked measurements': 'Không có chỉ số nào được theo dõi',
  'No video source': 'Không có nguồn video',
  'Non-dicom Data': 'Dữ liệu Non-dicom',
  'Not strong enough': 'Không đủ mạnh',
  'Number Of Copies': 'Số bản sao',
  'Only Super Admin can add new role':
    'Chỉ quản trị viên cấp cao mới có thể thêm nhóm quyền mới',
  'Only show failed files': 'Chỉ hiển thị các tệp lỗi',
  'Open Report': 'Xem báo cáo',
  'Open Viewer and Report': 'Xem ảnh và báo cáo',
  'Open Viewer': 'Xem ảnh',
  'Open in Split Window and Report': 'Mở trong cửa sổ chia nhỏ và báo cáo',
  'Open in Split Window': 'Mở trong cửa sổ chia nhỏ',
  'Order Date': 'Ngày chỉ định',
  'Order Doctor': 'Bác sĩ chỉ định',
  'Order Group': 'Mã chỉ định',
  'Order Information': 'Thông tin chỉ định',
  'Order List': 'Danh sách chỉ định',
  'Order Search': 'Tìm kiếm chỉ định',
  'Ordinal Number': 'Số thứ tự',
  'Page Number': 'Số trang',
  'Invalid Pass Code': 'Mã khóa không hợp lệ',
  'Invalid Citizen ID': 'CMND/CCCD không hợp lệ',
  'Pass Code Required': 'Yêu cầu mã',
  'Citizen ID Required': 'Yêu cầu số CMND/CCCD',
  'Password does not match': 'Mật khẩu không khớp',
  'Patient ID': 'Mã người bệnh',
  'Patient Info': 'Thông tin người bệnh',
  'Patient Information': 'Thông tin người bệnh',
  'Patient Name': 'Tên người bệnh',
  'Patient Search': 'Tìm kiếm người bệnh',
  'Patient Sex': 'Giới tính',
  'Patient Weight (kg)': 'Cân nặng',
  'Patient search': 'Tìm kiếm người bệnh',
  'Percentage of Max SUV': '',
  'Performance By Radiologist': 'Hiệu suất làm việc của bác sĩ',
  'Performed Studies': 'Ca đã chụp',
  'Phone Number': 'Số điện thoại',
  'Please allow access to your camera and microphone':
    'Please allow access to your camera and microphone',
  'Please enter a number': 'Vui lòng nhập vào số',
  'Please enter a positive number': 'Vui lòng nhập số dương',
  'Please enter note': 'Vui lòng nhập ghi chú',
  'Please enter password': 'Vui lòng nhập mật khẩu',
  'Print Page Range': 'In từ trang - đến trang',
  'Print Type': 'Kiểu in',
  'Procedure Code': 'Mã dịch vụ',
  'Procedure Group Name': 'Tên nhóm dịch vụ',
  'Procedure Group': 'Nhóm dịch vụ',
  'Procedure Name': 'Tên dịch vụ',
  'Procedure Search': 'Tìm kiếm dịch vụ',
  'Department Code': 'Mã khoa phòng',
  'Department Name': 'Tên khoa phòng',
  Department_Title: 'Khoa phòng',
  'Body Part Name': 'Tên bộ phận',
  'Processing...': 'Đang xử lý...',
  // 'ROI Threshold Configuration': '',
  'Rectangle Scalpel': 'Cắt hình chữ nhật',
  'Refer Doctor': 'Bác sĩ tham chiếu',
  'Reject latest report': 'Từ chối báo cáo mới nhất',
  'Remove Bed': 'Xóa giường',
  'Report History': 'Lịch sử báo cáo',
  'Report Template': 'Mẫu báo cáo',
  'Required value': 'Thông tin bắt buộc',
  'Reset password': 'Khôi phục mật khẩu',
  'Reset to Defaults': 'Khôi phục mặc định',
  'Role Code': 'Mã nhóm quyền',
  'Role Name': 'Tên nhóm quyền',
  'Rule CAD': 'Quy tắc cho CAD',
  'Rule Name': 'Tên quy tắc',
  'Scheduled Date': 'Ngày chỉ định',
  'Select Academic Rank': 'Chọn học hàm',
  'Select Account': 'Chọn tài khoản',
  'Select Auto Send to CAD': 'Chọn tự động gửi CAD',
  'Select CAD Tool': 'Chọn công cụ CAD',
  'Select Creator': 'Chọn người tạo',
  'Select Date': 'Chọn ngày',
  'Select Device Type': 'Chọn loại thiết bị',
  'Select Device': 'Chọn thiết bị',
  'Select Files': 'Chọn tệp',
  'Select Folder': 'Chọn thư mục',
  'Select Gender': 'Chọn giới tính',
  'Select Group Account': 'Chọn nhóm tài khoản',
  'Select Institution': 'Chọn cơ sở',
  'Select Institutions': 'Chọn cơ sở',
  'Select Facility': 'Chọn cơ sở',
  'Select Facilities': 'Chọn cơ sở',
  'Select Layout List': 'Chọn danh sách mẫu in',
  'Select Match status': 'Chọn trạng thái ghép nối',
  'Select Modality': 'Chọn loại thiết bị',
  'Select Order status': 'Chọn trạng thái chỉ định',
  'Select Procedure Group': 'Chọn nhóm dịch vụ',
  'Select Procedure Name': 'Chọn tên dịch vụ',
  'Select Role': 'Chọn nhóm quyền',
  'Select Roles': 'Chọn nhóm quyền',
  'Select Share By': 'Chọn người chia sẻ',
  'Select Share Type': 'Chọn kiểu chia sẻ',
  'Select Status': 'Chọn trạng thái',
  'Select Studylist status': 'Chọn trạng thái ca chụp',
  'Select Type': 'Chọn kiểu',
  'Select condition': 'Chọn điều kiện',
  'Select date range': 'Chọn khoảng thời gian',
  'Select date': 'Chọn ngày',
  'Select group': 'Chọn nhóm',
  'Select institutions': 'Chọn cơ sở',
  'Select Layout': 'Chọn mẫu in',
  'Select technician': 'Chọn kĩ thuật viên',
  'Select type': 'Chọn kiểu',
  'Selected study only': 'Ca chụp',
  'Share By': 'Người chia sẻ',
  'Share Link': 'Link chia sẻ',
  'Share Settings': 'Thiết lập chia sẻ',
  'Share Study': 'Chia sẻ ca chụp',
  'Share Type': 'Phạm vi chia sẻ',
  'Shared Date': 'Ngày chia sẻ',
  'Shared List': 'Danh sách chia sẻ',
  'Short Name': 'Tên viết tắt',
  'Show Annotations': 'Kèm theo chú giải',
  'Some files are not supported. Do you want to continue?':
    'Một số tệp không được hỗ trợ. Bạn có muốn tiếp tục?',
  'Split Window': 'Chia đôi màn hình',
  'Split Windows': 'Chia đôi màn hình',
  'Study Date': 'Ngày chụp',
  'Study Description': 'Mô tả ca chụp',
  'Study Information': 'Thông tin ca chụp',
  'Study Share': 'Chia sẻ ca chụp',
  'Submitted By': 'Người lưu báo cáo',
  'Template Code': 'Mã mẫu báo cáo',
  'Template Name': 'Tên mẫu',
  'Template Report': 'Mẫu báo cáo',
  'Text Size': 'Cỡ chữ',
  'This Month': 'Tháng này',
  Yesterday: 'Hôm qua',
  'Last 7 days': '7 ngày gần nhất',
  'This Year': 'Năm nay',
  'Last Year': 'Năm trước',
  'This template will overwrite your current work?':
    'Mẫu báo cáo này sẽ ghi đè nội dung hiện tại. Bạn có muốn tiếp tục?',
  // 'Total Dose (bq)': '',
  'Unavailable CAD': 'CAD chưa hỗ trợ',
  'Update AI result': 'Cập nhật kết quả AI',
  'Update Profile': 'Cập nhật thông tin',
  'Updated At': 'Thời gian cập nhật',
  'Upload Logo': 'Tải lên Logo',
  'Upload Signature': 'Tải lên chữ ký',
  'Upload file success': 'Tải tệp lên thành công',
  'Upload files': 'Tải lên danh sách tệp',
  'Upload image failed': 'Không tải được hình ảnh lên',
  'User List': 'Danh sách người dùng',
  'User Settings': 'Thiết lập người dùng',
  'UserPreferencesModal:User Preferences': 'Tùy chọn người dùng',
  'Username must be at least 4 characters':
    'Tên đăng nhập phải nhiều hơn 4 ký tự',
  'Username must be less than 50 characters':
    'Tên đăng nhập phải ít hơn 50 ký tự',
  'Username or Email': 'Tên đăng nhập hoặc email',
  'Visit ID mismatch': 'Mã lượt khám không khớp',
  'Visit ID': 'Mã lượt khám',
  'You need to match study with order or create new order':
    'Bạn cần ghép ca chụp với chỉ định hoặc tạo chỉ định mới',
  // 'Đăng ký gói MAX': '',
  AETitle: 'AETitle',
  APPROVED: 'ĐÃ DUYỆT',
  ARRIVED: 'ĐÃ ĐẾN',
  Abnormal: 'Có bất thường',
  Access: 'Phạm vi truy cập',
  Account: 'Tài khoản',
  Action: 'Thao tác',
  Actions: 'Thao tác',
  Active: 'Đang hoạt động',
  Add: 'Thêm',
  Address: 'Địa chỉ',
  Administration: 'Quản trị',
  Age: 'Tuổi',
  All: 'Tất cả',
  Apply: 'Áp dụng',
  Approve: 'Phê duyệt',
  Approved: 'Đã duyệt',
  Approver: 'Người phê duyệt',
  Arrived: 'Đã đến',
  Assign: 'Chỉ định',
  Assigned: 'Đã chỉ định',
  Back: 'Quay lại',
  Birthday: 'Ngày sinh',
  Bookmark: 'Đánh dấu',
  Border: 'Đường viền',
  CAD: 'CAD',
  CANCEL: 'HỦY',
  COMPLETED: 'ĐÃ THỰC HIỆN',
  Camera: 'Máy ảnh',
  Cancel: 'Hủy',
  Capture: 'Chụp hình',
  Clear: 'Xóa',
  ClearFilters: 'Xóa bộ lọc',
  Close: 'Đóng',
  Column: 'Cột',
  Completed: 'Đã thực hiện',
  Conclusion: 'Kết luận',
  Condition: 'Điều kiện',
  Confirm: 'Xác nhận',
  Connection: 'Kết nối',
  Content: 'Nội dung',
  Creator: 'Người tạo',
  Crosshairs: 'Vị trí tương quan',
  Custom: 'Tùy biến',
  DICOM: 'DICOM',
  Dashboard: 'Thống kê',
  Delete: 'Xóa',
  Description: 'Mô tả',
  // Destination: 'Điểm đến',
  Device: 'Thiết bị',
  Devices: 'Thiết bị',
  Diagnoses: 'Chẩn đoán',
  Diagnostic: 'Chẩn đoán',
  Download: 'Tải xuống',
  Edit: 'Chỉnh sửa',
  Email: 'Email',
  Empty: 'Nền',
  End: 'Đến',
  Export: 'Xuất Tệp',
  Female: 'Nữ',
  Finish: 'Hoàn thành',
  Forbidden: 'Bị cấm',
  Function: 'Chức năng',
  Gender: 'Giới tính',
  General: 'Tổng quát',
  Group: 'Nhóm',
  Help: 'Trợ giúp',
  High: 'Cao',
  Hotkeys: 'Phím tắt',
  Import: 'Thêm',
  Inactive: 'Không hoạt động',
  Information: 'Thông tin',
  Institution: 'Cơ sở',
  Facility: 'Cơ sở',
  Institutions: 'Cơ sở',
  Facilities: 'Cơ sở',
  Keyword: 'Từ khóa',
  LOAD: 'Tải',
  LOGIN: 'Đăng nhập',
  Language: 'Ngôn ngữ',
  Length: 'Thước đo',
  Loading: 'Đang tải',
  Login: 'Đăng nhập',
  Logout: 'Đăng xuất',
  MRN: 'MRN',
  Magnification: 'Độ phóng đại',
  Male: 'Nam',
  Matched: 'Đã thực hiện',
  Max: 'Tối đa',
  Microphone: 'Microphone',
  Min: 'Tối thiểu',
  Modality: 'Loại thiết bị',
  NEW: 'MỚI',
  New: 'Mới',
  Next: 'Tiếp theo',
  No: 'Không',
  Normal: 'Không thấy bất thường',
  Note: 'Ghi chú',
  // NumOfStudiesHiggerThan100Message: '',
  OK: 'Đồng ý',
  Open: 'Mở',
  Order: 'Chỉ định',
  Orders: 'Chỉ định',
  Orientation: 'Bố trí',
  Other: 'Khác',
  Overview: 'Tổng quan',
  Page: 'Trang',
  Paper: 'Giấy',
  Password: 'Mật khẩu',
  Patient: 'Người bệnh',
  Pending: 'Đang chờ',
  Permissions: 'Quyền',
  Phone: 'Số điện thoại',
  Port: 'Cổng',
  Preferences: 'Tùy chọn',
  Preview: 'Xem trước',
  // Previous: 'Trước đó',
  Print: 'In',
  Priority: 'Mức độ ưu tiên',
  Private: 'Cá nhân',
  Procedure: 'Dịch vụ',
  Processed: 'Đã xử lý',
  Profile: 'Thông tin cá nhân',
  Public: 'Công khai',
  Quality: 'Chất lượng',
  Quantity: 'Số lượng',
  READING: 'ĐANG ĐỌC',
  Reading: 'Đang đọc',
  Receive: 'Tiếp nhận',
  Reception: 'Tiếp đón',
  Report: 'Báo cáo',
  Reset: 'Đặt lại',
  Resolution: 'Độ phân giải',
  // ResultsPerPage: '',
  Retry: 'Thử lại',
  Role: 'Nhóm quyền',
  Roles: 'Nhóm quyền',
  Save: 'Lưu',
  Saving: 'Đang lưu',
  Scanner: 'Máy quét',
  Search: 'Tìm kiếm',
  // Segmentations: '',
  Select: 'Lựa chọn',
  Settings: 'Thiết lập',
  Sex: 'Giới tính',
  Share: 'Đã chia sẻ',
  ShareSettings: 'Thiết lập chia sẻ',
  Shortcut: 'Phím tắt',
  Signature: 'Chữ ký',
  Sorry: 'Xin lỗi',
  Spacing: 'Khoảng cách',
  Start: 'Bắt đầu',
  Status: 'Trạng thái',
  // Strategy: '',
  Studies: 'Danh sách ca chụp',
  StudyList: 'Danh sách ca chụp',
  Studylist: 'Danh sách ca chụp',
  Submit: 'Gửi',
  Technician: 'Kỹ thuật viên',
  // Thickness: '',
  Today: 'Hôm nay',
  Total: 'Tổng',
  Trim: 'Cắt',
  Type: 'Kiểu',
  Unmatched: 'Chưa ghép chỉ định',
  Upload: 'Tải lên',
  User: 'Người dùng',
  Username: 'Tên đăng nhập',
  Value: 'Giá trị',
  Warning: 'Cảnh báo',
  Worklist: 'Danh sách công việc',
  Yes: 'Đồng ý',
  browse: 'duyệt',
  columns: 'Cột',
  failed: 'thất bại',
  items: 'dòng',
  more: 'Hiển thị thêm',
  success: 'thành công',
  to: 'Đến',
  Expand: 'Mở rộng',
  Collapse: 'Thu gọn',
  'No Data': 'Không có dữ liệu',
  NO: 'STT',
  Sharing: 'Chia sẻ',
  Shared: 'Đã chia sẻ',
  Expired: 'Hết hạn',
  'Source AETitle': 'Nguồn AETitle',
  'Studylist Status': 'Trạng thái ca chụp',
  'Order Status': 'Trạng thái chỉ định',
  'All devices': 'Tất cả thiết bị',
  Unknown: 'Không xác định',
  Default: 'Mặc định',
  'My Templates': 'Mẫu của tôi',
  Guest: 'Khách',
  'Invalid phone number': 'số điện thoại không hợp lệ',
  'At least 10 numbers': 'Hãy điền ít nhất 10 số',
  'Please fill in number': 'Vui lòng chỉ điền số',
  'CAD|Yes': 'Có',
  Layout: 'Mẫu in báo cáo',
  Study: 'Ca chụp',
  Template: 'Mẫu báo cáo',
  Viewer: 'Xem ảnh',
  'Are you sure to delete dicom study?':
    'Bạn có chắc chắn muốn xóa ca chụp dicom?',
  'Are you sure delete this annotation?':
    'Bạn có chắc chắn muốn xóa chú thích này?',
  'Are you sure delete all annotations on this instance?':
    'Bạn có chắc chắn muốn xóa tất cả chú thích cho ảnh này?',
  "You don't have permission to access this page.":
    'Bạn không có quyền truy cập trang này.',
  'Upload Files': 'Tải tệp lên',
  'file(s)': 'tệp',

  "It's time to upgrade": 'THÔNG BÁO MUA GÓI',
  'You have reached the limit of your current plan': 'Quý khách đã sử dụng hết',
  '10 links per month': '10 lượt chia sẻ công khai / tháng',
  'Please register MAX package to continue using this feature':
    'Vui lòng đăng ký gói MAX để tiếp tục sử dụng tính năng này.',
  'Thank you!': 'Xin cảm ơn!',
  'Register now': 'Đăng ký gói MAX',
  'Dashboard Order': 'Thống kê chỉ định',
  'Order By Modality': 'Chỉ định theo loại thiết bị',
  'Top 5 Of Approver': 'Top 5 người phê duyệt',
  'Top 5 Of Procedure': 'Top 5 dịch vụ',
  'Close Camera': 'Đóng máy ảnh',
  'HIS Order List': 'Danh sách chỉ định HIS',
  'Enter PID': 'Nhập mã người bệnh',
  'Patient Visit List': 'Danh sách lượt khám',
  'Add HIS Order': 'Thêm chỉ định HIS',
  PID: 'Mã người bệnh',
  Department: 'Khoa thực hiện',
  'Procedure Date': 'Ngày chụp',
  'Enter Procedure Date': 'Nhập ngày chụp',
  'Ender Order': 'Nhập chỉ định',
  'Enter Note': 'Nhập ghi chú',
  'Enter Department': 'Nhập khoa thực hiện',
  'Open camera': 'Mở máy ảnh',

  "Order with accessionNumber {{ accession_number }} already exists. Can't create a new order.":
    'Đã tồn tại dịch vụ với mã {{ accession_number }}. Không thể tạo mới',

  'No image available for Accession Number {{ accession_number }}!':
    'Mã chỉ định {{ accession_number }} chưa có hình ảnh sẵn sàng!',

  'Image not available': 'Hình ảnh chưa sẵn sàng',
  'The exam is currently unavailable': 'Dữ liệu ca chụp chưa sẵn sàng',
  'Please reload the page or try again after 24 hours. If you continue to have issues, contact the Vinmec Hotline for assistance.':
    'Vui lòng tải lại trang hoặc quay lại sau 24h nữa. Trường hợp vẫn không xem được hình ảnh, vui lòng liên hệ Hotline Vinmec để được hỗ trợ.',
  'Please reload the page or try again after 24 hours. If you continue to have issues, contact the Hotline for assistance.':
    'Vui lòng tải lại trang hoặc quay lại sau 24h nữa. Trường hợp vẫn không xem được hình ảnh, vui lòng liên hệ Hotline để được hỗ trợ.',
  'The image viewing period has expired': 'Đã hết hạn xem ca chụp',
  'Contact the Vinmec hotline for support, or download the MyVinmec app and connect your medical records to continue viewing the images.':
    'Liên hệ Hotline Vinmec để được hỗ trợ hoặc tải app MyVinmec và kết nối hồ sơ y tế để tiếp tục xem hình ảnh ca chụp.',
  'Contact the hotline for support.': 'Liên hệ Hotline để được hỗ trợ',

  'Are you sure want to close the camera while recording?':
    'Bạn có muốn tắt máy ảnh trong khi đang ghi hình không?',
  'Shutting off the camera while recording will cause you to lose the video you are capturing.':
    'Tắt máy ảnh trong khi ghi hình có thể làm mất video bạn đang ghi.',
  'Continue Recording': 'Tiếp tục ghi hình',
  'Select Department': 'Chọn khoa thực hiện',
  'Select Body Part': 'Chọn bộ phận chụp',
  'No Report': 'Không có báo cáo',
  'This report is being modified by another user':
    'Báo cáo này đang được sửa đổi bởi người dùng khác',
  'This report is being modified by':
    'Báo cáo này đang được sửa đổi bởi người dùng',
  'No report available': 'Không có báo cáo',
  'No order available': 'Không có chỉ định',
  'Enter Scheduled Date': 'Nhập ngày chỉ định',
  'Your API key will appear here': 'API key sẽ hiển thị ở đây',
  'Patient Order List': 'Danh sách chỉ định',
  'Enter Device': 'Nhập tên thiết bị',
  'Select Match Status': 'Chọn trạng thái ghép',
  'Select Visit ID': 'Chọn mã lượt khám',
  'Enter Study Description': 'Nhập mô tả ca chụp',

  '{{ order_length }} order matched':
    '{{ order_length }} chỉ định đã được ghép',
  '{{ order_length }} orders matched':
    '{{ order_length }} chỉ định đã được ghép',
  '{{ order_length }} order unmatched':
    'Đã huỷ ghép {{ order_length }} chỉ định',
  '{{ order_length }} orders unmatched':
    'Đã huỷ ghép {{ order_length }} chỉ định',
  'Print Report': 'In báo cáo',
  Previous: 'Quay lại',
  'Import Data': 'Nhập dữ liệu',
  Images: 'Hình ảnh',
  'Print Layout': 'Mẫu bố cục in',
  'Powered by': 'Được cung cấp bởi',
  'Add New': 'Thêm mới',
  'View Study': 'Xem ca chụp',
  'Upload failed': 'Lỗi khi tải tệp lên',
  Success: 'Thành công',
  'Create Study successfully': 'Tạo ca chụp thành công',
  'Add New Study': 'Tạo ca chụp mới',
  'Open Studylist': 'Mở danh sách ca chụp',
  'Create Study': 'Tạo ca chụp',
  'Report saved successfully.': 'Lưu báo cáo thành công.',
  'Error occurred while saving the report. Please try again.':
    'Đã xảy ra lỗi khi lưu báo cáo. Vui lòng thử lại.',
  'Report approve successfully.': 'Phê duyệt báo cáo thành công.',
  'Error occurred while approving the report. Please try again.':
    'Đã xảy ra lỗi khi phê duyệt báo cáo. Vui lòng thử lại.',
  'Confirm Delete': 'Xác nhận xoá',
  'Are you sure you want to delete this item? This action cannot be undone.':
    'Bạn có chắc bạn muốn xóa tệp này? Hành động này không thể được hoàn tác.',
  'No matched study found': 'Không tìm thấy ca chụp phù hợp để ghép',
  'filter-management.Match': 'Đã thực hiện',
  'filter-management.Not Match': 'Chưa ghép chỉ định',
  "The report isn't ready yet": 'Báo cáo chưa sẵn sàng!',

  'Reset All Changes': 'Khôi phục tất cả thay đổi',
  'All unsaved changes will be removed.':
    'Tất cả các thay đổi chưa được lưu sẽ bị xóa.',
  'Proceed Anyway': 'Tiếp tục',
  'Go back': 'Quay lại',
  'Loading more...': 'Đang tải thêm...',
  'Shared By': 'Người chia sẻ',
  'Visited Date': 'Ngày khám',
  'Date of Birth': 'Ngày sinh',
  Notifications: 'Thông báo',

  'Link copied to clipboard.': 'Liên kết đã được sao chép.',
  "Couldn't copy. Please select the text and use Ctrl+C (Tap & hold on phone) to copy it manually.":
    'Không thể sao chép. Vui lòng chọn văn bản và sử dụng Ctrl+C (Nhấn và giữ trên điện thoại) để sao chép thủ công.',
  'Generate link first!': 'Xin hãy tạo liên kết trước!',
  'QR Code copied to clipboard.': 'QR Code đã được sao chép.',
  "Couldn't generate QR Code.": 'Không thể tạo QR Code.',
  'Password copied to clipboard.': 'Mật khẩu đã được sao chép.',
  'Copied to clipboard.': 'Nội dung đã được sao chép',
  'Copy Password': 'Sao chép mật khẩu',

  'Modify Columns': 'Chỉnh sửa cột',
  'Order Doctor Name': 'Bác sĩ chỉ định',
  'Referring Physician': 'Bác sĩ tham chiếu',
  'Study Status': 'Trạng thái ca chụp',
  Work: 'Công việc',
  'Find by Patient Name': 'Tìm theo tên bệnh nhân',
  Name: 'Tên',
  'Find by Patient ID': 'Tìm theo mã người bệnh',
  'Pull to refresh': 'Kéo để làm mới',
  MATCH: 'ĐÃ GHÉP',
  UNMATCH: 'CHƯA GHÉP',
  'Find by Institution Name': 'Tìm theo tên cơ sở',
  'From Date': 'Từ ngày',
  'To Date': 'Đến ngày',
  'Copy Link': 'Sao chép link',
  'Copy QR Code': 'Sao chép mã QR',
  'You are recording a video. Do you want to stop recording and upload the data?':
    'Bạn đang quay video. Có muốn dừng quay và tải lên dữ liệu không?',
  'Access Type': 'Phạm vi truy cập',
  'Update Order': 'Cập nhật chỉ định',
};
